// src/contexts/SettingsContext.tsx
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  ReactNode,
} from 'react';
import axiosClient from '../axiosClient'; // adjust to your setup
import { API_ENDPOINTS } from '../constants';

// Define the shape of a single setting
export interface Setting {
  id: number;
  group: string;
  key: string;
  label: string;
  value: string;
  type: string;
  meta: any; // Adjust to a specific type if known
  is_editable: boolean;
  created_at: string;
  updated_at: string;
}

// Define the context value type
interface SettingsContextType {
  settings: Setting[] | null;
}

// Create the context with default value
const SettingsContext = createContext<SettingsContextType>({
  settings: null,
});

// Props for the provider
interface SettingsProviderProps {
  children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({
  children,
}) => {
  const [settings, setSettings] = useState<Setting[] | null>(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axiosClient.get<Setting[]>(
          API_ENDPOINTS.GLOBAL_SETTINGS
        );
        setSettings(response.data);
      } catch (error) {
        console.error('Failed to load settings:', error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings }}>
      {children}
    </SettingsContext.Provider>
  );
};

// Hook to use the context
export const useSettings = (): SettingsContextType =>
  useContext(SettingsContext);
